import React from "react";
import "reactjs-popup/dist/index.css";
import { Card, Row, Col } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { FaFileAlt, FaCogs } from "react-icons/fa";
import "./CustomColumns.scss";
const CustomColumns = ({ columnData }) => {
    const navigate = useNavigate();
    return (
        columnData && columnData.length > 0 ? (
            <div className="cards-container">
                <Row className="custom-roww">
                    {columnData.map((item, index) => (
                        <Col key={index} className="custom-coll">
                            <Card
                                onClick={() => navigate(item.link)}
                                className="py-3 cursor_pointer row_cards"
                            >
                                <Card.Body className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <div className="icon-circle-column"
                                            style={{ backgroundColor: item.color }}>
                                            {item.imageComponent}

                                        </div>
                                        <div className="ms-4">
                                            <Card.Title className="fs-14px mb-1">{item.title}</Card.Title>
                                            <Card.Text className="fs-12px">{item.description}</Card.Text>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        ) : null
    );
};
export default CustomColumns;